import Capabilities from './../src/capabilities/index.js'
window.capabilities = new Capabilities()
